import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'pt-top-banner',
  templateUrl: './top-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./top-banner.component.scss'],
})
export class TopBannerComponent {
  @Input() sticky = false;
}
